import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { debounceTime, finalize, tap } from "rxjs/operators";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { KpiWidget } from "src/app/frontoffice/review/dashboard/models/dashboard.model";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "sepidz-kpi-widget",
  templateUrl: "./kpi-widget.component.html",
  styleUrls: ["./kpi-widget.component.scss"],
})
export class KpiWidgetComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  @Input() background: string; // list of valid css class exist in _background.scss
  @Input() icon: string;
  @Input() path: string;
  @Input() reload: Observable<boolean>;
  @Input() filters: NameValue[];
  @Input() data: KpiWidget;
  @Input() type: "string" | "number" | "boolean" | "date" | "time" | "dateTime" = "number";
  @Input() isLoading: boolean = true;

  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {
    if (this.path) {
      this.load();
      this.reloading();
    }
  }

  private reloading() {
    if (!this.reload) {
      return;
    }

    this.reload
      .pipe(
        debounceTime(300),
        tap((value) => {
          if (value) {
            this.load();
          }
        })
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe();
  }

  private load() {
    this.isLoading = true;
    const params = this.buildParams();
    this.httpClient
      .get(`${this.path}`, { params })
      .pipe(finalize(() => (this.isLoading = false)))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: KpiWidget) => {
        this.data = data;
      });
  }

  buildParams(): HttpParams | undefined {
    if (!this.filters) {
      return;
    }
    let params = new HttpParams();
    this.filters.forEach((f) => (params = params.append(f.Name, f.Value)));
    return params;
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.filters = undefined;
    this.data = undefined;
  }
}
